import { CodeBlockEditorDescriptor, CodeBlockEditorProps } from '@mdxeditor/editor'

/**
 * Read-only fallback renderer for fenced/indented code blocks.
 *
 * The markdown editor registers no language-specific code editors, so without a
 * catch-all descriptor MDXEditor throws `UnrecognizedMarkdownConstructError` on import
 * for ANY ``` block — surfacing in Sentry as
 * `Parsing of the following markdown structure failed: {"type":"code","name":"N/A"}`.
 * This happens with AI deliverables that wrap their answer in a ```markdown fence (or
 * include an indented block), and crashes the whole preview.
 *
 * `match: () => true` claims every code block regardless of language, so the import
 * visitor always finds a descriptor and renders the content as plain preformatted text
 * instead of crashing. Styling lives in `getMarkDownSx` (`.gap-code-block`) so it stays
 * dark-mode aware alongside the other markdown styles.
 */
function PlainCodeBlock(props: CodeBlockEditorProps) {
   return (
      <pre className="gap-code-block">
         <code>{props.code}</code>
      </pre>
   )
}

export const plainCodeBlockDescriptor: CodeBlockEditorDescriptor = {
   // Lowest priority so a more specific language editor could win if one is ever added.
   priority: -10,
   match: () => true,
   Editor: PlainCodeBlock,
}
